<div
	class="h-full overflow-hidden text-left bg-white border border-gray-200 rounded-lg shadow-xs"
>
	<a
		[routerLink]="['/guides', categoryUrl(), guide()?.gui_url ?? guide().url]"
		class="relative block w-full h-56 swiper-no-swiping"
	>
		<img
			[ngSrc]="guide()?.image ?? guide()?.img | cdn"
			fill
			alt="Guide Image Cover"
			class="object-cover bg-center"
		/>
	</a>
	<div class="p-5">
		<p class="text-xs font-bold tracking-wide text-gray-400 uppercase">
			{{ categoryGuide() }} Guides
		</p>
		<p class="text-xl font-bold text-gray-900">
			<a
				[routerLink]="['/guides', categoryUrl(), guide()?.gui_url ?? guide().url]"
				class="swiper-no-swiping"
			>
				<span class="text-xl font-bold text-gray-900">{{ guide()?.title }}</span>
			</a>
		</p>
		<!-- TODO remove one paragraph when the API response is standardised  -->
		@if (guide()?.quote) {
			<p class="text-gray-500 text-base flex pt-1.5">
				{{ guide()?.quote | truncate: ['60'] }}
			</p>
		}
		@if (guide()?.desc) {
			<p class="text-gray-500 text-base flex pt-1.5">
				{{ guide()?.desc | truncate: ['60'] }}
			</p>
		}
	</div>
</div>
